export const PRIVACY_POLICY = `Privacy Policy

Last Updated: January 2, 2026

1. INTRODUCTION

Brixen Credit LLC ("we," "us," or "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our credit repair software ("SaaS"), or engage our concierge services. By using our Site or Services, you consent to the data practices described in this policy.

2. INFORMATION WE COLLECT

We collect information necessary to facilitate credit analysis and dispute resolution:

Personal Identification Information: Name, email address, phone number, physical address, date of birth, Social Security Number (SSN), and identity document copies (Driver's License, Passport) required to validate your identity with credit bureaus.

Credit & Financial Information: Credit reports (imported from TransUnion, Equifax, Experian), payment history, negative account details (collections, late payments, bankruptcies), and monitoring service credentials if provided by you.

Technical Usage Data: IP address, browser type, and in-app behavior (letter generation, downloads), collected automatically via cookies.

3. HOW WE USE YOUR INFORMATION

We use the information we collect to:

Provide Services: Analyze credit reports, identify negative items, generate AI-powered dispute letters, and manage physical mail delivery (if applicable).

Communication: Contact you via email, phone, SMS, or WhatsApp regarding your dispute status, credit alerts, or account updates.

Improvement: Train our AI algorithms to improve dispute effectiveness (using anonymized data).

Security: Verify your identity to comply with federal regulations and prevent fraud.

4. SHARING YOUR INFORMATION & MESSAGING DISCLOSURES

Sharing information is necessary to execute disputes, but we strictly protect your contact data:

Operational Data Sharing: We may share your personal data (such as dispute letters and identity proofs) with Credit Bureaus (TransUnion, Equifax, Experian) and Original Creditors solely for the purpose of processing your disputes.

Strict Mobile Data Policy:

Customer data is NOT shared with 3rd parties for promotional or marketing purposes.

Mobile opt-in and consent are NEVER shared with anyone for any purpose. Any information sharing mentioned elsewhere in this policy excludes mobile opt-in data.

Messaging Terms: By providing your phone number, you consent to receive text messages from BRIXEN CREDIT LLC or from our verified number regarding customer care and dispute updates. Consent is not a condition of purchase. Message frequency varies. Message & data rates may apply. You can reply STOP to unsubscribe at any time or HELP for assistance.

5. DATA STORAGE CONSENT

By accepting this policy, you expressly grant Brixen Credit LLC permission to digitally store copies of your credit reports, identity documents, and generated correspondence for the duration of your subscription to maintain your case history.

6. DATA SECURITY

We use bank-level SSL encryption and secure servers to protect your sensitive information (SSN and credit reports). However, no electronic transmission over the Internet is 100% secure.

7. CONTACT US

Brixen Credit LLC

390 NE 191st St Ste 8123, Miami, FL 33179

Phone: 786-627-9073

Email: info@brixencredit.com`

export const TERMS_CONDITIONS = `Terms & Conditions

Brixen Credit LLC
Last Updated: January 2, 2026

1. AGREEMENT TO TERMS

These Terms and Conditions ("Terms") constitute a legally binding agreement between you ("Client," "You," or "User") and Brixen Credit LLC ("Brixen Credit," "Company," "We," "Us," or "Our"), governing your access to and use of our credit restoration services, website, client portal, and related systems (collectively, the "Services").

By registering, submitting a self sign-up, paying the initial audit fee, or otherwise engaging our Services, you acknowledge that you have read, understood, and agreed to be bound by these Terms.

2. NATURE OF SERVICES (DONE-FOR-YOU CREDIT RESTORATION)

Brixen Credit LLC is a credit restoration and consulting company, not a software provider and not a law firm.

Scope of Services

We provide Done-For-You credit restoration services, which include but are not limited to:

• Review and analysis of your consumer credit reports
• Preparation, submission, and management of dispute correspondence
• Communication with credit bureaus and furnishers
• Ongoing monitoring and strategy adjustments
• Client access to an online portal to review progress

All dispute letters and communications are generated, sent, and managed by Brixen Credit LLC on your behalf.

Not a Law Firm

Brixen Credit LLC does not provide legal advice. Our services are administrative and educational in nature and are based on consumer protection laws such as the Fair Credit Reporting Act (FCRA) and Fair Debt Collection Practices Act (FDCPA). Nothing herein shall be construed as legal representation.

3. FREE AUDIT, INITIAL FEE & SERVICE COMMENCEMENT

• Clients begin with a free credit consultation and audit
• A $1 initial audit and identity verification fee is charged at signup
• By completing the self sign-up, you authorize Brixen Credit LLC to charge the full service fee or first installment to your payment method on the next business day
• Services officially commence once payment is processed

4. PAYMENT TERMS, PLANS & BILLING AUTHORIZATION (CROA & TSR COMPLIANCE)

Monthly Plans & Term Commitment

• All credit restoration plans are monthly recurring services
• Clients agree to maintain their selected plan for a minimum of twelve (12) consecutive months
• Early cancellation does not relieve the Client of the remaining payment obligation unless otherwise required by law

Billing Authorization

By enrolling, you expressly authorize Brixen Credit LLC to:

• Charge your payment method on file according to your selected plan
• Process recurring monthly charges
• Reattempt failed payments

No Advance Fees for Results

In compliance with CROA and FTC Telemarketing Sales Rule (TSR):

• Payments are for services rendered, time, labor, and administrative work
• We do not charge or collect fees based on promised outcomes or guaranteed removals

5. CREDIT MONITORING REQUIREMENT (MYSCOREIQ)

Active credit monitoring through MyScoreIQ (or an equivalent approved provider) is mandatory for all clients.

You agree to:

• Maintain an active monitoring account at all times during service
• Provide and maintain login access for reporting purposes
• Use the portal to track progress and updates

Failure to maintain active monitoring may delay or suspend services.

6. NO GUARANTEE OF RESULTS (CROA DISCLOSURE)

In strict compliance with the Credit Repair Organizations Act (CROA):

NO GUARANTEE OF RESULTS: We do not and cannot guarantee the removal of specific accounts, items, or any increase in credit score.

Accurate Information: We cannot remove information that is accurate, complete, and verifiable under federal law.

Timeframes: Any timelines discussed are estimates only and are not contractual guarantees.

Results vary based on individual credit profiles, creditor responses, and bureau verification processes.

7. FTC IDENTITY THEFT REPORT AUTHORIZATION

When suspicious or potentially fraudulent accounts are identified, you authorize Brixen Credit LLC to:

• Assist in preparing and submitting FTC Identity Theft Reports
• File supporting documentation on your behalf
• Communicate with bureaus and creditors regarding identity theft disputes

Client Responsibility

You acknowledge and agree that:

• You are solely responsible for the accuracy of any information provided
• Any false statements or misrepresentation may result in legal consequences
• Brixen Credit LLC bears no liability for information provided by you

8. CLIENT OBLIGATIONS

You agree to:

• Provide accurate and truthful information
• Upload all creditor and bureau correspondence received
• Refrain from disputing information you know to be accurate
• Cooperate fully throughout the restoration process
• Regularly review your client portal

Failure to comply may result in suspension or termination of services.

9. COMMUNICATION CONSENT (TCPA COMPLIANCE)

By providing your contact information, you consent to receive:

• SMS, MMS, email, and phone communications
• Automated messages related to your account and services

Consent is not a condition of purchase. Reply STOP to opt out of SMS at any time.

10. LIMITATION OF LIABILITY

To the fullest extent permitted by law:

• Brixen Credit LLC shall not be liable for indirect, incidental, or consequential damages
• Total liability shall not exceed the amount paid by the Client in the previous three (3) months

11. TERMINATION

Brixen Credit LLC reserves the right to suspend or terminate services for:

• Non-payment
• Fraud or misrepresentation
• Abuse of the dispute process
• Failure to comply with these Terms

12. BINDING ARBITRATION & CLASS ACTION WAIVER

Any dispute shall be resolved through binding arbitration in Miami-Dade County, Florida. You waive any right to participate in a class action lawsuit.

13. GOVERNING LAW

These Terms shall be governed by the laws of the State of Florida.

14. CONTACT INFORMATION

Brixen Credit LLC
390 NE 191st St Ste 8123
Miami, FL 33179

Phone: 786-627-9073
Email: info@brixencredit.com`

export const REFUND_POLICY = `Refund Policy

Last Updated: January 2, 2026

1. RIGHT OF RESCISSION (3-DAY CANCELLATION)

You may cancel this transaction, without any penalty or obligation, within three (3) business days from the date the contract is signed or the service is purchased.

To cancel, you must notify us in writing via email at refunds@brixencredit.com before midnight of the third business day.

If you cancel within this period, any payments made will be returned within 10 days following receipt of your cancellation notice.

2. SERVICE REQUIREMENTS & ELIGIBILITY (MYSCOREIQ)

To receive our services, you must maintain an active credit monitoring subscription with MyScoreIQ at all times.

Brixen Credit LLC requires uninterrupted access to your credit report to analyze data and generate disputes. If your MyScoreIQ account is paused, cancelled, or the login credentials become invalid, we cannot perform the service.

Failure to maintain an active MyScoreIQ subscription constitutes a breach of your service agreement and voids any eligibility for refunds after the initial 3-day period.

3. NO GUARANTEE OF RESULTS

In compliance with the Credit Repair Organizations Act (CROA), Brixen Credit LLC does NOT guarantee specific results.

We cannot guarantee:

• The removal of any specific negative item.

• A specific increase in your credit score.

• A specific timeframe for results.

Results depend on the accuracy of the information reported by the bureaus and your individual credit profile. Consequently, we do not offer refunds based on the outcome of the disputes or the lack of score improvement.

4. GENERAL REFUND POLICY (AFTER 3 DAYS)

Due to the nature of our digital services and the immediate work performed upon onboarding:

• All subscription payments are non-refundable once the initial 3-day cancellation period has passed.

• Monthly subscription fees, setup fees, and document processing fees are final.

• You may cancel your subscription at any time to prevent future charges, but no prorated refunds will be issued for the current billing cycle.

5. NON-REFUNDABLE ITEMS

The following fees are never refundable under any circumstances:

• Third-Party Services: Payments made to MyScoreIQ or other monitoring services.

• Postage & Printing: Fees paid for "Done-For-You" printing or certified mail.

• Consultation Fees: Any one-time analysis fees once the service has been rendered.

6. CONTACT US

If you have any questions about this Refund Policy, please contact us:

Brixen Credit LLC

390 NE 191st St Ste 8123, Miami, FL 33179

Phone: 786-627-9073

Email: info@brixencredit.com`
